import * as React from "react";

export default class CV extends React.Component {
    render() {
        return (
            <p>Please come back later</p>

        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/cv/index.tsx